import React from "react";
import label from "../../labels/interviewProcess_en.json";

const Report = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.Report} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default Report;
